// extracted by css-extract-rspack-plugin
export default {"column":"LinkColumn-module__column__vXgUS","heading":"LinkColumn-module__heading__vyqWX","list":"LinkColumn-module__list__q5Tn1","item":"LinkColumn-module__item__nrsNE"};